import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const FileError = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 32 32" ref={ref} {...props}>
      <path d="M19.2 0H6.4C4.64 0 3.216 1.44 3.216 3.2L3.2 28.8c0 1.76 1.424 3.2 3.184 3.2H25.6c1.76 0 3.2-1.44 3.2-3.2V9.6L19.2 0zm-1.6 11.2V2.4l8.8 8.8h-8.8zm-3.201 3.199h3.2v8.534h-3.2v-8.534zm0 10.668h3.2v3.2h-3.2v-3.2z"/>
    </SvgIcon>
  );
});

FileError.displayName = "FileError";

export default FileError;
